module.exports = {"420583001":"马家店街道","420583101":"安福寺镇","420583102":"白洋镇","420583103":"顾家店镇","420583104":"董市镇","420583105":"仙女镇","420583106":"问安镇","420583107":"七星台镇","420583108":"百里洲镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420583.json
// module id = 1737
// module chunks = 0